import api from "../utils/api";
import { LOGOUT } from "./types";

export const manageable = () => async () => {
    const response = await api.get("/calendars/users/m");
    return response.data || response;
};

export const users = (calendarUuid) => async () => {
    const response = await api.get(`/calendars/users/u/${calendarUuid}`);
    return response.data || response;
};

export const update = (calendarUuid, userUuid, payload) => async () => {
    const response = await api.put(
        `/calendars/users/u/${calendarUuid}/${userUuid}`,
        payload
    );

    return response.data || response;
};

export const unshare = (calendarUuid, userUuid) => async () => {
    const response = await api.delete(
        `/calendars/users/u/${calendarUuid}/${userUuid}`
    );

    return response.data || response;
};

export const search = (calendarUuid, q) => async () => {
    const params = new URLSearchParams();

    if (q) {
        params.append("q", q);
    }

    const response = await api.get(
        `/calendars/users/s/${calendarUuid}?${params.toString()}`
    );

    return response.data || response;
};

export const share = (calendarUuid, payload) => async () => {
    const response = await api.post(
        `/calendars/users/u/${calendarUuid}`,
        payload
    );

    return response.data || response;
};